export default __webpack_public_path__ + "static/media/spinner.56c863bc.gif";